<template>
  <v-container max-width="100%" fluid style="margin-top: 2%;">
    <LoadingComponent :loading="loadingImportacao" message="Importando quadros..." />
    <!-- Alerta -->
    <!-- Dialogo de confirmação de exclusão de quadro-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogQuadro" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudQuadros.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialogQuadro = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                @click="deleteQuadroFromDatabase">{{ this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de confirmação de substituição de quadro-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogSubst" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudQuadros.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="closeConfirmSubst">{{ this.messageDismissButton
              }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="substQuadroAtivo">{{
                $t('button.substitute') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de aviso de encerramento das escalas do quadro versionado -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogEscalas" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudQuadros.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ $t('crudQuadros.messages.confirmCloseSchedules') }}</span>
              <ul class="mt-2">
                <li v-for="escala in escalasAbertasQuadro" :key="escala.id_escala">{{ escala.descricao }}</li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="closeConfirmEscalas">{{
                $t('crudQuadros.messages.cancel') }}</v-btn>
              <v-btn color="red accent-4" class="white--text" @click="confirmVersionamentoComEscalas">{{
                $t('crudQuadros.messages.confirmCloseSchedulesButton') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de confirmação de atualização de quadro futuro -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogUpdate" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #4a4a4a">{{ $t('crudQuadros.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #4a4a4a">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="closeConfirmUpdate">{{ this.messageDismissButton
              }}</v-btn>
              <v-btn v-if="showConfirmButton" color="primary" class="white--text" @click="confirmUpdateQuadro">{{
                $t('button.update') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de confirmação de exclusão de viagem-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogViagem" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudQuadros.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialogViagem = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="removeViagem">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de confirmação de importação de quadros-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogImportacao" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #4a4a4a">{{ $t('crudQuadros.messages.processingResult') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #4a4a4a">{{ this.mensagemProcessamentoImportacao }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="confirmDialogImportacao = false">{{
                $t('crudQuadros.messages.cancel') }}</v-btn>
              <v-btn v-if="showImportButton" color="primary" class="white--text" @click="importarQuadros">{{
                $t('crudQuadros.messages.import') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-container>
      <!-- Tabela de quadros -->
      <merus-data-table
        :headers="headersQuadrosWithProperties"
        :items="quadrosFiltrados"
        :mostrar-inativos="true"
        item-key="id_quadro"
        show-expand
        :single-expand="true"
        :loading="loadingQuadros"
        :default-multi-sort="defaultSortQuadros"
        :loading-text="$t('groups.loading')"
        @update:displayedItems="displayedItemsForExport = $event" cod-tabela="QUADROS__QUADROS_WITH_PROPERTIES" @update:headers="headersQuadrosWithProperties = $event">
        <template v-slot:expanded-item="{ headers, item }">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>{{ $t('crudQuadros.headers.trips.departureTime') }}</th>
                  <th>{{ $t('crudQuadros.headers.trips.arrivalTime') }}</th>
                  <th>{{ $t('crudQuadros.headers.trips.direction') }}</th>
                  <th>{{ $t('crudQuadros.headers.trips.shift') }}</th>
                  <th>{{ $t('crudQuadros.headers.trips.escalation') }}</th>
                  <th>{{ $t('crudQuadros.headers.trips.capacity') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="viagem in item.viagens" :key="viagem.id_viagem">
                  <td>{{ viagem.horario_saida }}</td>
                  <td>{{ viagem.horario_chegada }}</td>
                  <td>{{ viagem.descricao_sentido }}</td>
                  <td>{{ viagem.descricao_turno }}</td>
                  <td>{{ viagem.escalonamento }}</td>
                  <td>{{ viagem.lotacao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
        <template v-slot:toolbar>
          <CadastroToolbar :token="token" :user="user.id_usuario" :title="$t('crudQuadros.title')" hide-search
            :items="displayedItemsForExport !== null ? displayedItemsForExport : quadrosFiltrados" :csv-title="$t('crudQuadros.title')" :csv-headers="headersCSV" :pdf-title="$t('crudQuadros.title')"
            :pdf-headers="headersQuadrosWithProperties" :pdf-filename="$t('crudQuadros.title')" :help-dialog-csv-fields="helpCSV"
            :help-dialog-csv-model="$tc('crudQuadros.title', 2)" :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvquadros/' : null" @saveBulk="saveQuadro">
            <template v-slot:add v-if="canInsert">
              <v-dialog v-model="quadrosDialog" max-width="100%">
                <!-- botão para mostrar o dialog de cadastro/edição de quadros -->
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline" style="color: #4a4a4a">{{
                      formTitleQuadro
                      }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="formValidado">
                        <v-row>
                          <v-col cols="12" sm="10" md="12">
                            <v-text-field v-model="editedQuadro.descricao"
                              :label="$t('crudQuadros.form.fields.description')"
                              :rules="[(v) => !!v || $t('crudQuadros.validation.descriptionRequired')]"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="4">
                            <v-select v-model="empresaSelected" :items="empresas" item-text="razao_social"
                              item-value="id_empresa" :label="$t('crudQuadros.form.fields.selectCompany')"
                              :disabled="isEmpresaDisabled" @change="empresaChanged"></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="8">
                            <LazySelect
                              ref="linhaSelect"
                              get-url="getLinhaslazy"
                              text="nome_linha"
                              value="id_linha"
                              :label="$t('crudQuadros.form.fields.selectLine')"
                              :rules="[(v) => !!v || $t('crudQuadros.validation.lineRequired')]"
                              :disabled="isLinhaDisabled || !empresaSelected"
                              :item-filter="linhaItemFilter"
                              :key="'linha-' + (empresaSelected != null ? empresaSelected : 'none')"
                              @input="onLinhaInput"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="4">
                            <v-select v-model="editedQuadro.id_categoria_quadro" :items="categorias"
                              item-text="descricao_categoria" item-value="id_categoria_quadro"
                              :label="$t('crudQuadros.form.fields.selectCategory')"
                              :rules="[(v) => !!v || $t('crudQuadros.validation.categoryRequired')]"
                              :disabled="isCategoriaDisabled" @change="categoriaChanged"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-datetime-picker :label="$t('crudQuadros.form.fields.validityStart')"
                              v-model="inicioVigencia" ref="inicioVigenciaInput" :time-picker-props="timeProps"
                              :text-field-props="textFieldPropsInicio" time-format="HH:mm" date-format="dd/MM/yyyy"
                              :clear-text="$t('crudQuadros.messages.close')" :disabled="isInicioDisabled">
                              <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                              </template>
                              <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                              </template>
                            </v-datetime-picker>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-datetime-picker :label="$t('crudQuadros.form.fields.validityEnd')" v-model="fimVigencia"
                              ref="fimVigenciaInput" :time-picker-props="timeProps"
                              :text-field-props="textFieldPropsFim" time-format="HH:mm" date-format="dd/MM/yyyy"
                              :clear-text="$t('crudQuadros.messages.close')">
                              <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                              </template>
                              <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                              </template>
                            </v-datetime-picker>
                          </v-col>
                        </v-row>
                        <div id="frequenciaquadro">
                          <v-row>
                            <span class="headline"
                              :style="[isFrequenciaDisabled ? { 'color': 'gray' } : { 'color': 'primary' }]">{{
                                $t('crudQuadros.form.fields.frequency') }}</span>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_segunda"
                                :label="$t('crudQuadros.form.fields.monday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_terca"
                                :label="$t('crudQuadros.form.fields.tuesday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_quarta"
                                :label="$t('crudQuadros.form.fields.wednesday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_quinta"
                                :label="$t('crudQuadros.form.fields.thursday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_sexta"
                                :label="$t('crudQuadros.form.fields.friday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_sabado"
                                :label="$t('crudQuadros.form.fields.saturday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="4" md="1">
                              <v-checkbox v-model="editedQuadro.valido_domingo"
                                :label="$t('crudQuadros.form.fields.sunday')" color="primary"
                                :disabled="isFrequenciaDisabled"></v-checkbox>
                            </v-col>
                          </v-row>
                        </div>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">

                            <!-- Tabela de viagens por quadro -->
                            <v-data-table :headers="headersViagens" :items="editedQuadro.viagens"
                              :search="searchViagens" sort-by="id_viagem" dense class="elevation-7" locale="pt"
                              style="border-radius: 10px;">

                              <template v-slot:top>
                                <v-toolbar flat color="white" style="border-radius: 10px;">
                                  <v-toolbar-title style="color: #4a4a4a">{{ viagensTableTitle }}</v-toolbar-title>
                                  <v-spacer></v-spacer>
                                  <v-text-field v-model="searchViagens" append-icon="mdi-magnify"
                                    :label="$t('crudQuadros.search')" single-line hide-details></v-text-field>
                                  <v-spacer></v-spacer>

                                  <vue-json-to-csv :json-data="editedQuadro.viagens"
                                    :csv-title="`viagensquadro${editedQuadro.id_quadro}`" separator=";">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                                          <v-icon>mdi-export-variant</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>{{ $t('crudQuadros.exportToCsv') }}</span>
                                    </v-tooltip>
                                  </vue-json-to-csv>

                                  <ExportTablePdf :title="viagensTableTitle" :content="editedQuadro.viagens"
                                    :headers="headersViagens" filename="viagensquadro"></ExportTablePdf>

                                  <v-dialog v-model="viagensDialog" max-width="60%">
                                    <!-- botão para mostrar o dialog de cadastro/edição de viagens -->
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn color="primary" :dark="!isViagensDisabled" small class="mb-2"
                                        v-bind="attrs" v-on="on" fab :disabled="isViagensDisabled">
                                        <v-icon>mdi-plus</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-card>
                                      <v-card-title>
                                        <span class="headline" style="color: #4a4a4a">{{
                                          formTitleViagem
                                          }}</span>
                                      </v-card-title>

                                      <v-card-text>
                                        <v-container>
                                          <v-form ref="formViagem" v-model="formViagemValidado">
                                            <v-row>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-datetime-picker :label="$t('crudQuadros.form.fields.departureTime')"
                                                  v-model="horarioSaida" ref="horarioSaidaInput"
                                                  :time-picker-props="timeProps" :text-field-props="textFieldPropsHorarioSaida"
                                                  time-format="HH:mm" date-format="dd/MM/yyyy"
                                                  :clear-text="$t('crudQuadros.messages.close')">
                                                  <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                  </template>
                                                  <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                  </template>
                                                </v-datetime-picker>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="6">
                                                <v-datetime-picker :label="$t('crudQuadros.form.fields.arrivalTime')"
                                                  v-model="horarioChegada" ref="horarioChegadaInput"
                                                  :time-picker-props="timeProps" :text-field-props="textFieldPropsHorarioChegada"
                                                  time-format="HH:mm" date-format="dd/MM/yyyy"
                                                  :clear-text="$t('crudQuadros.messages.close')">
                                                  <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                  </template>
                                                  <template slot="timeIcon">
                                                    <v-icon>mdi-clock</v-icon>
                                                  </template>
                                                </v-datetime-picker>
                                              </v-col>
                                            </v-row>
                                            <v-row>
                                              <v-col cols="12" sm="6" md="3">
                                                <v-select v-model="editedViagem.id_sentido"
                                                  :label="$t('crudQuadros.form.fields.direction')" :items="sentidos"
                                                  item-text="descricao_sentido" item-value="id_sentido"
                                                  :rules="[(v) => !!v || $t('crudQuadros.validation.directionRequired')]"></v-select>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="3">
                                                <v-select v-model="editedViagem.id_turno"
                                                  :label="$t('crudQuadros.form.fields.shift')" :items="turnosFiltrados"
                                                  item-text="descricao_turno" item-value="id_turno"
                                                  :rules="[(v) => !!v || $t('crudQuadros.validation.shiftRequired')]"></v-select>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="3">
                                                <v-text-field v-model="editedViagem.escalonamento"
                                                  :label="$t('crudQuadros.form.fields.escalation')" solo clearable
                                                  single-line type="number"
                                                  :rules="[escalonamentoRules]"></v-text-field>
                                              </v-col>
                                              <v-col cols="12" sm="6" md="3">
                                                <v-text-field v-model="editedViagem.lotacao"
                                                  :label="$t('crudQuadros.form.fields.capacity')" solo clearable
                                                  single-line type="number" min="0"
                                                  :rules="[lotacaoRules]"></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-form>
                                        </v-container>
                                      </v-card-text>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary darken-1" class="white--text" @click="closeViagem">{{
                                          $t('crudQuadros.messages.cancel') }}</v-btn>
                                        <v-btn color="primary darken-1" class="white--text" @click="saveViagem">{{
                                          $t('crudQuadros.messages.save') }}</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </v-toolbar>
                              </template>
                              <template v-slot:item.actions="{ item }">
                                <v-icon small class="mr-2" color="green" @click="editViagem(item)"
                                  :disabled="isViagensDisabled">mdi-pencil</v-icon>
                                <v-icon small class="mr-2" color="red" @click="deleteViagem(item)"
                                  :disabled="isViagensDisabled">mdi-delete</v-icon>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-textarea v-model="editedQuadro.observacoes"
                              :label="$t('crudQuadros.form.fields.observations')" auto-grow clearable counter rows="1"
                              :rules="[(v) => (!v || v.length <= 1000) || $t('crudQuadros.validation.maxCharacters')]"></v-textarea>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" class="white--text" @click="closeQuadro">{{
                      $t('crudQuadros.messages.cancel')
                    }}</v-btn>
                    <v-btn color="primary darken-1" class="white--text" @click="saveQuadro">{{
                      $t('crudQuadros.messages.save')
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>

            <template v-slot:extension>
              <v-switch
                v-model="mostrarInativos"
                :label="$t('crudVeiculos.showInactive')"
                class="ml-3 mr-4"
                hide-details
              ></v-switch>
              <v-dialog v-model="importDialog" max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark small class="mb-2 mr-2" fab v-bind="attrs" v-on="on">
                    <v-icon>mdi-file-import</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar color="primary" class="white--text mb-2">
                    <v-btn icon dark @click="closeImportDialog">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('crudQuadros.title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <UploadDialog v-if="importFormValidated" :token="token" :endpoint="'/api/v1.0/processacsvcittati/'"
                      :url-params="[inicioVigenciaImportacaoFormatted, fimVigenciaImportacaoFormatted]"
                      icon="mdi-file-import" fileType="csv" size="s" @done="handleDone" @error="handleError" />
                  </v-toolbar>
                  <v-card-text>
                    <v-form ref="importForm" v-model="importFormValidated">
                      <v-datetime-picker :label="$t('crudQuadros.form.fields.validityStart')"
                        v-model="inicioVigenciaImportacao" ref="inicioVigenciaImportacaoInput"
                        :time-picker-props="timeProps" :text-field-props="textFieldPropsInicio" time-format="HH:mm"
                        date-format="dd/MM/yyyy" :clear-text="$t('crudQuadros.messages.close')">
                        <template slot="dateIcon">
                          <v-icon>mdi-calendar</v-icon>
                        </template>
                        <template slot="timeIcon">
                          <v-icon>mdi-clock</v-icon>
                        </template>
                      </v-datetime-picker>
                      <v-datetime-picker :label="$t('crudQuadros.form.fields.validityEnd')"
                        v-model="fimVigenciaImportacao" ref="fimVigenciaImportacaoInput" :time-picker-props="timeProps"
                        :text-field-props="textFieldPropsFim" time-format="HH:mm" date-format="dd/MM/yyyy"
                        :clear-text="$t('crudQuadros.messages.close')">
                        <template slot="dateIcon">
                          <v-icon>mdi-calendar</v-icon>
                        </template>
                        <template slot="timeIcon">
                          <v-icon>mdi-clock</v-icon>
                        </template>
                      </v-datetime-picker>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>

            </template>
          </CadastroToolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click.stop="editQuadro(item)"
            :disabled="!item.editavel || !!item.cancelado || !canEdit">mdi-pencil</v-icon>
          <v-icon small class="mr-2" color="red" @click.stop="deleteQuadro(item)"
            :disabled="!item.editavel || !!item.cancelado || !canDelete">mdi-delete</v-icon>
        </template>
      </merus-data-table>
    </v-container>
  </v-container>
</template>

<style lang="css"></style>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import UploadDialog from "./Dialogs/UploadDialog.vue";
import LoadingComponent from "./LoadingComponent.vue";
import EventBus from "../utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import VueJsonToCsv from "vue-json-to-csv";
import ExportTablePdf from "./ExportTablePdf.vue";
import LazySelect from "./Selects/LazySelect.vue";

export default {
  components: { CadastroToolbar, MerusDataTable, UploadDialog, LoadingComponent, VueJsonToCsv, ExportTablePdf, LazySelect },
  data: () => ({
    headersQuadrosWithProperties: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    formViagemValidado: true,
    mensagemUpload: "",
    quadrosDialog: false,
    viagensDialog: false,
    operacao: 0,
    isAtivo: false,
    confirmDialogQuadro: false,
    confirmDialogViagem: false,
    confirmDialogSubst: false,
    confirmDialogUpdate: false,
    confirmDialogEscalas: false,
    // Escalas vigentes do quadro que será versionado; fecham junto com ele.
    escalasAbertasQuadro: [],
    quadroOriginalVersionamento: null,
    updateExisting: false,
    quadroConflito: null,
    pendingCsvPayload: null,
    pendingCsvBoardIndex: 0,
    csvBulkSaving: false,
    csvBulkConflictMode: null,
    helpDialog: false,
    mensagemdialog: "",
    horaProgramada: null,
    isQuadroDisabled: false,
    loadingQuadros: false,
    isEmpresaDisabled: false,
    isLinhaDisabled: false,
    isCategoriaDisabled: false,
    isFrequenciaDisabled: false,
    isViagensDisabled: false,
    isInicioDisabled: false,
    // Viagens do quadro como estavam ao abrir a edição; diz se o save precisa mexer nelas.
    viagensSnapshot: null,
    deletedViagemIndex: -1,
    inicioVigencia: null,
    fimVigencia: null,
    horarioSaida: null,
    horarioChegada: null,
    frequencia: [],
    uploadDialog: false,
    formUploadValidado: true,
    idempresaupload: null,
    arquivoCsv: null,
    fileLoading: false,
    fimProcesso: false,
    arquivoLog: null,
    substitute: false,
    uploadMessageColor: 'primary',
    textFieldPropsFim: {
      prependInnerIcon: "mdi-calendar",
    },
    timeProps: {
      useSeconds: false,
    },
    sentidos: [],
    turnos: [],
    quadros: [],
    mostrarInativos: false,
    displayedItemsForExport: null,
    quadrosAtivos: [],
    viagens: [],
    empresas: [],
    linhas: [],
    categorias: [],
    syncingLazySelects: false,
    empresaSelected: null,
    editedIndexQuadro: -1,
    uploadResultDialog: false,
    showSaveButton: false,
    resultCSV: [],
    editedQuadro: {
      id_quadro: null,
      id_linha: null,
      id_empresa: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      id_categoria_quadro: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      viagens: [],
      observacoes: null,
      cancelado: 0,
    },
    deletedQuadro: {
      id_quadro: null,
      id_linha: null,
      id_empresa: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      id_categoria_quadro: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      viagens: [],
      observacoes: null,
      cancelado: 0,
    },
    defaultQuadro: {
      id_quadro: null,
      id_linha: null,
      id_empresa: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      id_categoria_quadro: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      viagens: [],
      observacoes: null,
      cancelado: 0,
    },
    editedIndexViagem: -1,
    editedViagem: {
      id_viagem: null,
      id_quadro: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      lotacao: null,
    },
    deletedViagem: {
      id_viagem: null,
      id_quadro: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      lotacao: null,
    },
    defaultViagem: {
      id_viagem: null,
      id_quadro: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      lotacao: null,
    },
    recursos: [],
    confirmDialogImportacao: false,
    mensagemProcessamentoImportacao: "",
    quadrosImportacao: [],
    showImportButton: false,
    loadingImportacao: false,
    importDialog: false,
    importFormValidated: false,
    inicioVigenciaImportacao: null,
    fimVigenciaImportacao: null,
    searchViagens: "",
    permissoes: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
    quadrosFiltrados() {
      // "Inativo" em quadros é cancelado; `ativo` é só vigência e permanece 1 após desativar.
      if (!this.mostrarInativos) {
        return this.quadros.filter((q) => Number(q.cancelado) !== 1);
      }
      return this.quadros;
    },
    defaultSortQuadros() {
      return [
        { value: 'cancelado', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'ativo', options: { text: this.$t('system.labels.decreasing'), value: -1 } },
        { value: 'editavel', options: { text: this.$t('system.labels.decreasing'), value: -1 } }];
    },
    messageDismissButton() { return this.$t('button.dismiss') },
    messageConfirmButton() { return this.$t('button.confirm') },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    textFieldPropsInicio() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
      }
    },
    textFieldPropsHorarioSaida() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('crudQuadros.validation.timeRequired')],
      }
    },
    textFieldPropsHorarioChegada() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('crudQuadros.validation.timeRequired')],
      }
    },
    formTitleQuadro() {
      return this.editedIndexQuadro === -1 ? this.$t('crudQuadros.form.title.create') : this.$t('crudQuadros.form.title.edit');
    },
    formTitleViagem() {
      return this.editedIndexViagem === -1 ? this.$t('crudQuadros.form.tripTitle.create') : this.$t('crudQuadros.form.tripTitle.edit');
    },
    viagensTableTitle() {
      return this.editedIndexQuadro === -1 ? this.$t('crudQuadros.form.tripsTableTitle.default') : this.$t('crudQuadros.form.tripsTableTitle.withDescription', { description: this.editedQuadro.descricao });
    },
    headersViagens() {
      return [
        { text: this.$t('crudQuadros.headers.trips.idTrip'), value: "id_viagem", align: " d-none" },
        { text: this.$t('crudQuadros.headers.trips.departureTime'), value: "horario_saida" },
        { text: this.$t('crudQuadros.headers.trips.arrivalTime'), value: "horario_chegada" },
        { text: this.$t('crudQuadros.headers.trips.direction'), value: "descricao_sentido" },
        { text: this.$t('crudQuadros.headers.trips.shift'), value: "descricao_turno" },
        { text: this.$t('crudQuadros.headers.trips.escalation'), value: "escalonamento" },
        { text: this.$t('crudQuadros.headers.trips.capacity'), value: "lotacao" },
        { text: this.$t('crudQuadros.headers.trips.actions'), value: "actions", align: "end", sortable: false },
      ];
    },
    linhaItemFilter() {
      const idEmpresa = this.empresaSelected;
      return (item) => {
        if (!item || idEmpresa == null || idEmpresa === '') {
          return false;
        }
        return Number(item.id_empresa) === Number(idEmpresa);
      };
    },
    turnosFiltrados() {
      const linha = (this.linhas || []).find(
        (l) => Number(l.id_linha) === Number(this.editedQuadro.id_linha)
      );
      const ids = linha && Array.isArray(linha.unidades)
        ? linha.unidades.map((x) => Number(x)).filter((x) => !Number.isNaN(x))
        : [];
      if (!ids.length) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => !t.id_unidade || ids.includes(Number(t.id_unidade))
      );
    },
    headersCSV() {
      return [
        { text: this.$t('crudQuadros.headers.csv.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('crudQuadros.headers.csv.company'), value: "cod_empresa", error: "error_empresa" },
        { text: this.$t('crudQuadros.headers.csv.line'), value: "cod_linha", error: "error_linha" },
        { text: this.$t('crudQuadros.headers.csv.description'), value: "descricao", error: "error_descrição" },
        { text: this.$t('crudQuadros.headers.csv.category'), value: "cod_categoria", error: "error_categoria" },
        { text: this.$t('crudQuadros.headers.csv.validityStart'), value: "dt_inicio_vigencia", error: "error_dt_inicio", warning: "warning_dt_inicio" },
        { text: this.$t('crudQuadros.headers.csv.validityEnd'), value: "dt_fim_vigencia", error: "error_dt_fim", warning: "warning_dt_fim" },
        { text: this.$t('crudQuadros.headers.csv.monday'), value: "valido_segunda", error: "error_valido_segunda" },
        { text: this.$t('crudQuadros.headers.csv.tuesday'), value: "valido_terca", error: "error_valido_terca" },
        { text: this.$t('crudQuadros.headers.csv.wednesday'), value: "valido_quarta", error: "error_valido_quarta" },
        { text: this.$t('crudQuadros.headers.csv.thursday'), value: "valido_quinta", error: "error_valido_quinta" },
        { text: this.$t('crudQuadros.headers.csv.friday'), value: "valido_sexta", error: "error_valido_sexta" },
        { text: this.$t('crudQuadros.headers.csv.saturday'), value: "valido_sabado", error: "error_valido_sabado" },
        { text: this.$t('crudQuadros.headers.csv.sunday'), value: "valido_domingo", error: "error_valido_domingo" },
        { text: this.$t('crudQuadros.headers.csv.departure'), value: "horario_saida", error: "error_horario_saida" },
        { text: this.$t('crudQuadros.headers.csv.arrival'), value: "horario_chegada", error: "error_horario_chegada" },
        { text: this.$t('crudQuadros.headers.csv.direction'), value: "cod_sentido", error: "error_sentido" },
        { text: this.$t('crudQuadros.headers.csv.shift'), value: "cod_turno", error: "error_turno" },
        { text: this.$t('crudQuadros.headers.csv.escalation'), value: "escalonamento", error: "error_escalonamento" },
        { text: this.$t('crudQuadros.headers.csv.capacity'), value: "lotacao", error: "error_lotacao" }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('crudQuadros.helpCsv.companyCode.label'),
          description: this.$t('crudQuadros.helpCsv.companyCode.description'),
          example: this.$t('crudQuadros.helpCsv.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('crudQuadros.helpCsv.lineCode.label'),
          description: this.$t('crudQuadros.helpCsv.lineCode.description'),
          example: this.$t('crudQuadros.helpCsv.lineCode.example'),
          key: "cod_linha"
        },
        {
          label: this.$t('crudQuadros.helpCsv.description.label'),
          description: this.$t('crudQuadros.helpCsv.description.description'),
          example: this.$t('crudQuadros.helpCsv.description.example'),
          key: "descricao"
        },
        {
          label: this.$t('crudQuadros.helpCsv.categoryCode.label'),
          description: this.$t('crudQuadros.helpCsv.categoryCode.description'),
          example: this.$t('crudQuadros.helpCsv.categoryCode.example'),
          key: "cod_categoria"
        },
        {
          label: this.$t('crudQuadros.helpCsv.validityStart.label'),
          description: this.$t('crudQuadros.helpCsv.validityStart.description'),
          example: this.$t('crudQuadros.helpCsv.validityStart.example'),
          key: "dt_inicio_vigencia"
        },
        {
          label: this.$t('crudQuadros.helpCsv.validityEnd.label'),
          description: this.$t('crudQuadros.helpCsv.validityEnd.description'),
          example: this.$t('crudQuadros.helpCsv.validityEnd.example'),
          key: "dt_fim_vigencia"
        },
        {
          label: this.$t('crudQuadros.helpCsv.monday.label'),
          description: this.$t('crudQuadros.helpCsv.monday.description'),
          example: this.$t('crudQuadros.helpCsv.monday.example'),
          key: "valido_segunda"
        },
        {
          label: this.$t('crudQuadros.helpCsv.tuesday.label'),
          description: this.$t('crudQuadros.helpCsv.tuesday.description'),
          example: this.$t('crudQuadros.helpCsv.tuesday.example'),
          key: "valido_terca"
        },
        {
          label: this.$t('crudQuadros.helpCsv.wednesday.label'),
          description: this.$t('crudQuadros.helpCsv.wednesday.description'),
          example: this.$t('crudQuadros.helpCsv.wednesday.example'),
          key: "valido_quarta"
        },
        {
          label: this.$t('crudQuadros.helpCsv.thursday.label'),
          description: this.$t('crudQuadros.helpCsv.thursday.description'),
          example: this.$t('crudQuadros.helpCsv.thursday.example'),
          key: "valido_quinta"
        },
        {
          label: this.$t('crudQuadros.helpCsv.friday.label'),
          description: this.$t('crudQuadros.helpCsv.friday.description'),
          example: this.$t('crudQuadros.helpCsv.friday.example'),
          key: "valido_sexta"
        },
        {
          label: this.$t('crudQuadros.helpCsv.saturday.label'),
          description: this.$t('crudQuadros.helpCsv.saturday.description'),
          example: this.$t('crudQuadros.helpCsv.saturday.example'),
          key: "valido_sabado"
        },
        {
          label: this.$t('crudQuadros.helpCsv.sunday.label'),
          description: this.$t('crudQuadros.helpCsv.sunday.description'),
          example: this.$t('crudQuadros.helpCsv.sunday.example'),
          key: "valido_domingo"
        },
        {
          label: this.$t('crudQuadros.helpCsv.departureTime.label'),
          description: this.$t('crudQuadros.helpCsv.departureTime.description'),
          example: this.$t('crudQuadros.helpCsv.departureTime.example'),
          key: "horario_saida"
        },
        {
          label: this.$t('crudQuadros.helpCsv.arrivalTime.label'),
          description: this.$t('crudQuadros.helpCsv.arrivalTime.description'),
          example: this.$t('crudQuadros.helpCsv.arrivalTime.example'),
          key: "horario_chegada"
        },
        {
          label: this.$t('crudQuadros.helpCsv.directionCode.label'),
          description: this.$t('crudQuadros.helpCsv.directionCode.description'),
          example: this.$t('crudQuadros.helpCsv.directionCode.example'),
          key: "cod_sentido"
        },
        {
          label: this.$t('crudQuadros.helpCsv.shift.label'),
          description: this.$t('crudQuadros.helpCsv.shift.description'),
          example: this.$t('crudQuadros.helpCsv.shift.example'),
          key: "cod_turno"
        },
        {
          label: this.$t('crudQuadros.helpCsv.escalation.label'),
          description: this.$t('crudQuadros.helpCsv.escalation.description'),
          example: this.$t('crudQuadros.helpCsv.escalation.example'),
          key: "escalonamento"
        },
        {
          label: this.$t('crudQuadros.helpCsv.capacity.label'),
          description: this.$t('crudQuadros.helpCsv.capacity.description'),
          example: this.$t('crudQuadros.helpCsv.capacity.example'),
          key: "lotacao"
        }];
    },
    dataAtual() {
      var dtAtual = new Date().toJSON().slice(0, 10);
      return dtAtual;
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    inicioVigenciaImportacaoFormatted() {
      return this.inicioVigenciaImportacao ? DateUtils.getDateSQLFormatted(this.inicioVigenciaImportacao) : null;
    },
    fimVigenciaImportacaoFormatted() {
      return this.fimVigenciaImportacao ? DateUtils.getDateSQLFormatted(this.fimVigenciaImportacao) : null;
    },
  },
  watch: {
    inicioVigencia(val) {
      if (!val) {
        this.$refs.inicioVigenciaInput.clearHandler();
      }
    },
    fimVigencia(val) {
      if (!val) {
        this.$refs.fimVigenciaInput.clearHandler();
      }
    },
    horarioSaida(val) {
      if (!val && this.$refs.horarioSaidaInput) {
        this.$refs.horarioSaidaInput.clearHandler();
      }
    },
    horarioChegada(val) {
      if (!val && this.$refs.horarioChegadaInput) {
        this.$refs.horarioChegadaInput.clearHandler();
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.formViagem) {
        this.$refs.formViagem.resetValidation();
      }
    },
    quadrosDialog(val) {
      if (val && this.editedIndexQuadro === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
    },
    empresas() {
      if (this.quadrosDialog && this.editedIndexQuadro === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
    },
    'editedQuadro.id_linha'() {
      if (
        this.editedViagem.id_turno != null &&
        !this.turnosFiltrados.some((t) => Number(t.id_turno) === Number(this.editedViagem.id_turno))
      ) {
        this.editedViagem.id_turno = null;
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() {
    this.$root.$emit('eventshowback', true);
  },
  methods: {

    initialize() {
      this.populaCategorias();
      this.populaRecursos();
      this.populaLinhas();
      this.populaEmpresas();
      this.populaSentidos();
      this.populaTurnos();
    },
    populaQuadros() {
      this.loadingQuadros = true;
      apiController.request(apiController.endpoints.getallQuadros, {
        onSuccess: (response) => {
          this.quadros = (response.data || []).map((quadro) => {
              // Traduz a descrição da categoria
              const categoria = this.categorias.find(c => c.id_categoria_quadro === quadro.id_categoria_quadro);
              if (categoria) {
                quadro.descricao_categoria = categoria.descricao_categoria;
              }
              return quadro;
            });
          this.populaViagens();
        },
        onError: () => {
          this.loadingQuadros = false;
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaQuadros();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatequadro");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertquadro");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletequadro");
            this.populaQuadros();
          },
        });
      }
    },
    populaViagens() {
      apiController.request(apiController.endpoints.getallViagensprevistas, {
        onSuccess: (response) => {
          // Traduzir o campo descricao_sentido de cada viagem
          const trips = response.data.map((viagem) => {
            const translated = translateDbField(
              viagem.translation_key_sentido,
              viagem.descricao_sentido
            );
            return {
              ...viagem,
              descricao_sentido: translated
            };
          });

          this.quadros = this.quadros.map((q) => {
            q.viagens = trips.filter((v) => v.id_quadro === q.id_quadro);
            return q;
          });
          this.quadrosAtivos = this.quadros.filter((q) => q.cancelado == 0 && q.editavel == 1);
          this.loadingQuadros = false;
        },
        onError: () => {
          this.loadingQuadros = false;
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = Array.isArray(response.data) ? response.data : [];
        },
      });
    },
    populaCategorias() {
      apiController.request(apiController.endpoints.getCategoriasquadros, {
        onSuccess: (response) => {
          this.categorias = response.data.map((categoria) => {
            const translated = translateDbField(
              categoria.translation_key,
              categoria.descricao_categoria
            );
            return {
              ...categoria,
              descricao_categoria: translated
            };
          });
        },
      });
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        onSuccess: (response) => {
          this.sentidos = response.data.map((sentido) => {
            const translated = translateDbField(
              sentido.translation_key,
              sentido.descricao_sentido
            );
            return {
              ...sentido,
              descricao_sentido: translated
            };
          });
        },
      });
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        onSuccess: (response) => {
          this.turnos = response.data;
        },
      });
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.quadrosDialog || this.editedIndexQuadro !== -1 || this.isEmpresaDisabled) {
        return;
      }
      if (this.empresaSelected != null && this.empresaSelected !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.empresaSelected = this.empresas[0].id_empresa;
      this.empresaChanged();
    },
    empresaChanged() {
      if (this.syncingLazySelects) {
        return;
      }
      this.editedQuadro.id_linha = null;
      this.resetLazySelectRef('linhaSelect');
    },
    onLinhaInput(val) {
      this.editedQuadro.id_linha = val;
    },
    resetLazySelectRef(refName) {
      const ref = this.$refs[refName];
      if (ref && typeof ref.resetData === 'function') {
        ref.resetData();
      }
    },
    seedAndSetLazySelect(refName, valueKey, item, id) {
      const ref = this.$refs[refName];
      if (!ref) {
        return;
      }
      if (item != null && id != null && id !== '' && typeof ref.cacheSelectedItems === 'function') {
        ref.cacheSelectedItems([item], valueKey);
      }
      if (typeof ref.setData === 'function') {
        ref.setData(id != null && id !== '' ? id : null);
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    syncLinhaLazySelect() {
      const linha =
        (this.linhas || []).find((l) => Number(l.id_linha) === Number(this.editedQuadro.id_linha)) ||
        (this.editedQuadro.id_linha != null
          ? {
              id_linha: this.editedQuadro.id_linha,
              nome_linha: this.editedQuadro.nome_linha || this.editedQuadro.cod_linha,
              id_empresa: this.editedQuadro.id_empresa,
            }
          : null);
      this.syncingLazySelects = true;
      this.seedAndSetLazySelect('linhaSelect', 'id_linha', linha, this.editedQuadro.id_linha);
      this.$nextTick(() => {
        this.syncingLazySelects = false;
      });
    },
    categoriaChanged() {
      if (this.editedQuadro.id_categoria_quadro === 2) {
        this.editedQuadro.valido_segunda = 0;
        this.editedQuadro.valido_terca = 0;
        this.editedQuadro.valido_quarta = 0;
        this.editedQuadro.valido_quinta = 0;
        this.editedQuadro.valido_sexta = 0;
        this.editedQuadro.valido_sabado = 0;
        this.editedQuadro.valido_domingo = 0;
        this.isFrequenciaDisabled = true;
      } else {
        this.isFrequenciaDisabled = false;
      }
    },
    horarioRules(hora) {
      if (hora == null) {
        return this.$t('crudQuadros.validation.timeRequired');
      }
      else {
        if (hora.length === 0) {
          return this.$t('crudQuadros.validation.timeRequired');
        }
        else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('crudQuadros.validation.invalidTime');
          }
          else {
            return true;
          }
        }
      }
    },
    editQuadro(quadro) {
      this.editedIndexQuadro = this.quadros.indexOf(quadro);
      this.editedQuadro = Object.assign({}, quadro);
      // Cópia própria: editar/excluir viagem no dialog não pode alterar a tabela antes do save.
      this.editedQuadro.viagens = (quadro.viagens || []).map((v) => Object.assign({}, v));
      this.viagensSnapshot = this.serializeViagens(this.editedQuadro.viagens);
      this.inicioVigencia = this.editedQuadro.dt_inicio_vigencia === null ? null : new Date(this.editedQuadro.dt_inicio_vigencia);
      this.fimVigencia = this.editedQuadro.dt_fim_vigencia === null ? null : new Date(this.editedQuadro.dt_fim_vigencia);
      this.empresaSelected = this.editedQuadro.id_empresa;
      this.isViagensDisabled = false;
      this.isEmpresaDisabled = true;
      this.isLinhaDisabled = true;
      this.isCategoriaDisabled = true;
      this.isInicioDisabled = true;
      this.isFrequenciaDisabled = false;
      this.quadrosDialog = true;
      this.$nextTick(() => this.syncLinhaLazySelect());
    },
    editViagem(viagem) {
      this.editedIndexViagem = this.editedQuadro.viagens.indexOf(viagem);
      this.editedViagem = Object.assign({}, viagem);
      this.editedViagem.id_quadro = this.editedQuadro.id_quadro;
      
      // Converte horários de string para Date
      if (viagem.horario_saida) {
        const today = new Date();
        const [hours, minutes] = viagem.horario_saida.split(':');
        this.horarioSaida = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours), parseInt(minutes));
      }
      if (viagem.horario_chegada) {
        const today = new Date();
        const [hours, minutes] = viagem.horario_chegada.split(':');
        this.horarioChegada = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours), parseInt(minutes));
      }
      
      this.viagensDialog = true;
    },
    showHelpDialog() {
      this.helpDialog = true;
    },
    closeHelpDialog() {
      this.helpDialog = false;
    },
    deleteQuadro(quadro) {
      this.deletedQuadro = Object.assign({}, quadro);
      this.mensagemdialog = this.$t('crudQuadros.messages.confirmDeactivation', { description: quadro.descricao });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('crudQuadros.messages.no');
      this.messageConfirmButton = this.$t('crudQuadros.messages.yes');
      this.confirmDialogQuadro = true;
    },
    deleteViagem(viagem) {
      // Pelo índice: viagens novas ainda não têm id_viagem para identificá-las.
      this.deletedViagemIndex = this.editedQuadro.viagens.indexOf(viagem);
      this.deletedViagem = Object.assign({}, viagem);
      this.mensagemdialog = this.$t('crudQuadros.messages.confirmTripDeletion', { time: viagem.horario_saida });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('crudQuadros.messages.no');
      this.messageConfirmButton = this.$t('crudQuadros.messages.yes');
      this.confirmDialogViagem = true;
    },
    deleteQuadroFromDatabase() {
      this.operacao = 3;
      this.confirmDialogQuadro = false;
      apiController.request(apiController.endpoints.desativaQuadro, {
        data: this.deletedQuadro,
        onSuccess: (response) => {
          this.updateQuadrosTable(response.data.erro);
        },
      });

    },
    removeViagem() {
      if (this.deletedViagemIndex !== -1) {
        this.editedQuadro.viagens.splice(this.deletedViagemIndex, 1);
      }
      this.confirmDialogViagem = false;
      this.$nextTick(() => {
        this.deletedViagemIndex = -1;
        this.deletedViagem = Object.assign({}, this.defaultViagem);
        this.mensagemdialog = "";
        this.showConfirmButton = false;
        this.messageDismissButton = "";
        this.messageConfirmButton = "";
      });
    },
    closeQuadro() {
      if (this.quadrosDialog) {
        this.quadrosDialog = false;
        this.$nextTick(() => {
          this.editedQuadro = Object.assign({}, this.defaultQuadro);
          this.deletedQuadro = Object.assign({}, this.defaultQuadro);
          this.editedIndexQuadro = -1;
          this.empresaSelected = null;
          this.isFrequenciaDisabled = false;
          this.isViagensDisabled = false;
          this.isEmpresaDisabled = false;
          this.isLinhaDisabled = false;
          this.isCategoriaDisabled = false;
          this.isInicioDisabled = false;
          this.viagensSnapshot = null;
          this.isAtivo = false;
          this.inicioVigencia = null;
          this.fimVigencia = null;
          this.resetLazySelectRef('linhaSelect');
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    },
    closeViagem() {
      this.viagensDialog = false;
      this.$nextTick(() => {
        this.editedViagem = Object.assign({}, this.defaultViagem);
        this.deletedViagem = Object.assign({}, this.defaultViagem);
        this.editedIndexViagem = -1;
        this.horarioSaida = null;
        this.horarioChegada = null;
        if (this.$refs.horarioSaidaInput) {
          this.$refs.horarioSaidaInput.clearHandler();
        }
        if (this.$refs.horarioChegadaInput) {
          this.$refs.horarioChegadaInput.clearHandler();
        }
        if (this.$refs.formViagem) {
          this.$refs.formViagem.resetValidation();
        }
      });
    },
    findQuadroAtivoConflitoIndex(quadro) {
      return this.quadrosAtivos.findIndex((q) => {
        let inicioVigencia = DateUtils.getDateSQLFormatted(new Date(q.dt_inicio_vigencia));
        let fimVigencia = DateUtils.getDateSQLFormatted(new Date(q.dt_fim_vigencia));

        let linhaIgual = q.id_linha == quadro.id_linha;
        let categoriaIgual = q.id_categoria_quadro == quadro.id_categoria_quadro;

        let vigenciaIgual =
          (q.dt_fim_vigencia === null && quadro.dt_inicio_vigencia > inicioVigencia) ||
          (quadro.dt_inicio_vigencia < fimVigencia && quadro.dt_inicio_vigencia > inicioVigencia) ||
          (quadro.dt_fim_vigencia > inicioVigencia && quadro.dt_fim_vigencia < fimVigencia);

        let frequenciaIgual = (q.valido_segunda == quadro.valido_segunda && q.valido_segunda == 1) ||
          (q.valido_terca == quadro.valido_terca && q.valido_terca == 1) ||
          (q.valido_quarta == quadro.valido_quarta && q.valido_quarta == 1) ||
          (q.valido_quinta == quadro.valido_quinta && q.valido_quinta == 1) ||
          (q.valido_sexta == quadro.valido_sexta && q.valido_sexta == 1) ||
          (q.valido_sabado == quadro.valido_sabado && q.valido_sabado == 1) ||
          (q.valido_domingo == quadro.valido_domingo && q.valido_domingo == 1);

        return linhaIgual && categoriaIgual && vigenciaIgual && frequenciaIgual;
      });
    },
    findQuadroConflito(quadro) {
      if (!quadro) {
        return null;
      }
      const excludeId = quadro.id_quadro || null;

      if (quadro.descricao) {
        const descricao = String(quadro.descricao).trim().toLowerCase();
        const matches = this.quadros.filter((q) =>
          q.descricao &&
          String(q.descricao).trim().toLowerCase() === descricao &&
          (!quadro.id_linha || Number(q.id_linha) === Number(quadro.id_linha)) &&
          Number(q.cancelado) === 0 &&
          (!excludeId || Number(q.id_quadro) !== Number(excludeId))
        );
        if (matches.length > 0) {
          return matches.sort((a, b) => Number(b.id_quadro) - Number(a.id_quadro))[0];
        }
      }

      const idx = this.findQuadroAtivoConflitoIndex(quadro);
      if (idx === -1) {
        return null;
      }
      const found = this.quadrosAtivos[idx];
      if (excludeId && Number(found.id_quadro) === Number(excludeId)) {
        return null;
      }
      return found;
    },
    isQuadroVigente(quadro) {
      if (!quadro) {
        return false;
      }
      if (quadro.ativo != null) {
        return Number(quadro.ativo) === 1;
      }
      const inicio = new Date(quadro.dt_inicio_vigencia);
      if (isNaN(inicio.getTime())) {
        return false;
      }
      const fim = quadro.dt_fim_vigencia ? new Date(quadro.dt_fim_vigencia) : null;
      const now = Date.now();
      return inicio.getTime() <= now && (fim === null || isNaN(fim.getTime()) || fim.getTime() >= now);
    },
    isQuadroFuturo(quadro) {
      if (!quadro || !quadro.dt_inicio_vigencia) {
        return false;
      }
      const inicio = new Date(quadro.dt_inicio_vigencia);
      return !isNaN(inicio.getTime()) && inicio.getTime() > Date.now();
    },
    promptQuadroConflito(conflito) {
      this.quadroConflito = conflito;
      if (this.csvBulkSaving) {
        this.mensagemdialog = this.$t('crudQuadros.messages.confirmCsvBulkUpdate');
        this.$nextTick(() => {
          this.confirmDialogUpdate = true;
        });
        return true;
      }
      if (this.isQuadroFuturo(conflito)) {
        this.mensagemdialog = this.$t('crudQuadros.messages.confirmUpdateFuture');
        this.$nextTick(() => {
          this.confirmDialogUpdate = true;
        });
        return true;
      }
      this.mensagemdialog = this.$t('crudQuadros.messages.confirmSubstitution');
      this.$nextTick(() => {
        this.confirmDialogSubst = true;
      });
      return true;
    },
    ajustarQuadroAnteriorSubstituicao(quadroAnterior, novoQuadro) {
      let anterior = Object.assign({}, quadroAnterior);
      let inicioVigenciaAnterior = !anterior.dt_inicio_vigencia ? null : DateUtils.getDateSQLFormatted(new Date(anterior.dt_inicio_vigencia));
      let fimVigenciaAnterior = !anterior.dt_fim_vigencia ? null : DateUtils.getDateSQLFormatted(new Date(anterior.dt_fim_vigencia));

      if (inicioVigenciaAnterior < novoQuadro.dt_inicio_vigencia) {
        if (fimVigenciaAnterior === null || (fimVigenciaAnterior > novoQuadro.dt_inicio_vigencia && (fimVigenciaAnterior < novoQuadro.dt_fim_vigencia || novoQuadro.dt_fim_vigencia === null))) {
          anterior.dt_fim_vigencia = novoQuadro.dt_inicio_vigencia;
          anterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(anterior.dt_inicio_vigencia));
        } else if (fimVigenciaAnterior > novoQuadro.dt_inicio_vigencia && fimVigenciaAnterior > novoQuadro.dt_fim_vigencia) {
          anterior.dt_inicio_vigencia = novoQuadro.dt_fim_vigencia;
          anterior.dt_fim_vigencia = DateUtils.getDateSQLFormatted(new Date(anterior.dt_fim_vigencia));
        }
      } else {
        if (fimVigenciaAnterior === null || (novoQuadro.dt_fim_vigencia !== null && inicioVigenciaAnterior < novoQuadro.dt_fim_vigencia)) {
          anterior.dt_inicio_vigencia = novoQuadro.dt_fim_vigencia;
          anterior.dt_fim_vigencia = DateUtils.getDateSQLFormatted(new Date(anterior.dt_fim_vigencia));
        } else {
          anterior.dt_fim_vigencia = novoQuadro.dt_inicio_vigencia;
          anterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(anterior.dt_inicio_vigencia));
        }
      }

      if (anterior.dt_fim_vigencia <= anterior.dt_inicio_vigencia) {
        anterior.cancelado = 1;
      }
      if (
        novoQuadro.descricao &&
        String(anterior.descricao).trim().toLowerCase() === String(novoQuadro.descricao).trim().toLowerCase()
      ) {
        anterior.descricao = `${anterior.descricao}_${anterior.id_quadro}`;
      }
      anterior.dt_inicio_vigencia = this.normalizeVigenciaForApi(anterior.dt_inicio_vigencia);
      anterior.dt_fim_vigencia = anterior.dt_fim_vigencia
        ? this.normalizeVigenciaForApi(anterior.dt_fim_vigencia)
        : null;
      return anterior;
    },
    abortCsvBulkSave() {
      this.csvBulkSaving = false;
      this.csvBulkConflictMode = null;
      this.pendingCsvPayload = null;
      this.pendingCsvBoardIndex = 0;
    },
    async skipCurrentCsvBoard() {
      this.quadroConflito = null;
      this.substitute = false;
      this.updateExisting = false;
      this.pendingCsvBoardIndex++;
      if (!this.pendingCsvPayload || this.pendingCsvBoardIndex >= this.pendingCsvPayload.boards.length) {
        this.finishCsvBulkSave();
        return;
      }
      await this.reloadQuadrosList();
      await this.saveQuadro(this.pendingCsvPayload);
    },
    applyCsvBulkConflictResolution(conflito) {
      this.quadroConflito = conflito;
      this.applyUpdateQuadroExistente();
    },
    cancelOutrosQuadrosMesmaDescricao(existente, quadro) {
      const descricao = String(quadro.descricao).trim().toLowerCase();
      const outros = this.quadros.filter((q) =>
        Number(q.id_quadro) !== Number(existente.id_quadro) &&
        Number(q.cancelado) === 0 &&
        Number(q.id_linha) === Number(quadro.id_linha) &&
        q.descricao &&
        String(q.descricao).trim().toLowerCase() === descricao
      );
      outros.forEach((q) => {
        apiController.request(apiController.endpoints.updateQuadro, {
          data: this.buildQuadroApiPayload({ ...q, cancelado: 1 }),
          silent: true,
        });
      });
    },
    onQuadroInsertComplete(erro) {
      if (erro) {
        if (this.csvBulkSaving) {
          this.abortCsvBulkSave();
        }
        this.updateQuadrosTable(true);
        return;
      }
      if (this.csvBulkSaving && this.pendingCsvPayload) {
        this.onCsvBoardSaveSuccess();
      } else {
        this.pendingCsvPayload = null;
        this.pendingCsvBoardIndex = 0;
        this.updateQuadrosTable(false);
      }
    },
    async onCsvBoardSaveSuccess() {
      this.quadroConflito = null;
      this.pendingCsvBoardIndex++;
      if (!this.pendingCsvPayload || this.pendingCsvBoardIndex >= this.pendingCsvPayload.boards.length) {
        this.finishCsvBulkSave();
        return;
      }
      await this.reloadQuadrosList();
      await this.saveQuadro(this.pendingCsvPayload);
    },
    finishCsvBulkSave() {
      const count = this.pendingCsvPayload?.boards?.length || 0;
      const wasUpsert = this.csvBulkConflictMode === 'upsert';
      this.csvBulkSaving = false;
      this.csvBulkConflictMode = null;
      this.pendingCsvPayload = null;
      this.pendingCsvBoardIndex = 0;
      this.editedQuadro = this.defaultQuadro;
      EventBus.$emit('show-alert', {
        mensagem: count > 1
          ? this.$t(
            wasUpsert ? 'crudQuadros.messages.successBulkUpsert' : 'crudQuadros.messages.successBulkInsert',
            { count }
          )
          : this.$t('crudQuadros.messages.successInsert'),
        tipo: 'success',
      });
      this.closeQuadro();
      this.closeUploadResultDialog();
      this.closeUploadDialog();
      this.initialize();
    },
    executeInsertQuadro() {
      apiController.request(apiController.endpoints.insertQuadro, {
        data: this.buildQuadroApiPayload(this.editedQuadro),
        silent: true,
        onSuccess: (response) => {
          this.quadroConflito = null;
          const viagens = this.editedQuadro.viagens || [];
          if (viagens.length > 0) {
            this.insertViagensBulk(response.data.insertId);
          } else {
            this.onQuadroInsertComplete(response.data.erro);
          }
        },
        onError: (error) => this.handleQuadroApiConflict(error),
      });
    },
    reloadQuadrosList() {
      return new Promise((resolve) => {
        apiController.request(apiController.endpoints.getallQuadros, {
          silent: true,
          onSuccess: (response) => {
            this.quadros = (response.data || []).map((quadro) => {
                const categoria = this.categorias.find((c) => c.id_categoria_quadro === quadro.id_categoria_quadro);
                if (categoria) {
                  quadro.descricao_categoria = categoria.descricao_categoria;
                }
                return quadro;
              });
            this.quadrosAtivos = this.quadros.filter((q) => q.cancelado == 0 && q.editavel == 1);
            resolve();
          },
          onError: () => resolve(),
        });
      });
    },
    getErrorHttpStatus(error) {
      return error?.response?.status ?? error?.response?.data?.meta?.httpStatus ?? null;
    },
    async handleQuadroApiConflict(error) {
      const status = this.getErrorHttpStatus(error);
      if (status === 409 && !this.substitute && !this.updateExisting) {
        await this.reloadQuadrosList();
        const conflito = this.findQuadroConflito(this.editedQuadro);
        if (conflito) {
          if (this.csvBulkSaving && this.csvBulkConflictMode) {
            this.applyCsvBulkConflictResolution(conflito);
            return;
          }
          this.promptQuadroConflito(conflito);
          return;
        }
      }
      if (this.csvBulkSaving) {
        this.abortCsvBulkSave();
      }
      EventBus.$emit('show-error', { error });
    },
    applyUpdateQuadroExistente() {
      const existente = this.quadroConflito;
      if (!existente) {
        this.updateExisting = false;
        return;
      }
      const merged = Object.assign({}, existente, this.editedQuadro, {
        id_quadro: existente.id_quadro,
        cancelado: existente.cancelado || 0,
      });
      const payload = this.buildQuadroApiPayload(merged);
      this.operacao = 1;
      this.updateExisting = false;
      apiController.request(apiController.endpoints.updateQuadro, {
        data: payload,
        silent: true,
        onSuccess: () => {
          this.quadroConflito = null;
          if (this.csvBulkSaving) {
            this.cancelOutrosQuadrosMesmaDescricao(existente, this.editedQuadro);
          }
          const viagens = this.editedQuadro.viagens || [];
          if (viagens.length > 0) {
            this.editedQuadro.id_quadro = existente.id_quadro;
            this.updateViagens();
          } else {
            this.onQuadroInsertComplete(false);
          }
        },
        onError: (error) => this.handleQuadroApiConflict(error),
      });
    },
    prepareCsvBoardState(quadroNovo, boardIndex) {
      this.formValidado = true;
      this.editedIndexQuadro = -1;
      this.pendingCsvBoardIndex = boardIndex;
      this.editedQuadro = Object.assign({}, quadroNovo.boards[boardIndex]);
      this.editedQuadro.id_quadro = null;
      const trips = quadroNovo.trips || [];
      this.editedQuadro.viagens = trips.filter((t) => Number(t.quadro_index) === boardIndex);
    },
    async saveQuadro(quadroNovo) {
      if (quadroNovo && quadroNovo.boards && Array.isArray(quadroNovo.boards) && quadroNovo.boards.length > 0) {
        if (!this.substitute && !this.updateExisting) {
          if (!this.csvBulkSaving) {
            this.pendingCsvPayload = quadroNovo;
            this.pendingCsvBoardIndex = 0;
            this.csvBulkSaving = true;
            await this.reloadQuadrosList();
          } else {
            this.pendingCsvPayload = quadroNovo;
          }
        }
        const boardIndex = this.pendingCsvBoardIndex != null ? this.pendingCsvBoardIndex : 0;
        this.prepareCsvBoardState(this.pendingCsvPayload || quadroNovo, boardIndex);
      } else if (this.substitute || this.updateExisting) {
        if (this.pendingCsvPayload) {
          const boardIndex = this.pendingCsvBoardIndex != null ? this.pendingCsvBoardIndex : 0;
          this.prepareCsvBoardState(this.pendingCsvPayload, boardIndex);
        }
      }

      if (!this.formValidado && this.$refs.form) {
        this.$refs.form.validate();
      } else if (!this.formValidado && this.csvBulkSaving) {
        this.formValidado = true;
      }

      if (this.formValidado) {
        let quadro = this.editedQuadro;
        if (!this.editedQuadro.dt_inicio_vigencia) {
          this.editedQuadro.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(this.inicioVigencia);
        }

        if (!this.editedQuadro.dt_fim_vigencia) {
          this.editedQuadro.dt_fim_vigencia = DateUtils.getDateSQLFormatted(this.fimVigencia);
        }

        this.editedQuadro.dt_inicio_vigencia = this.normalizeVigenciaForApi(this.editedQuadro.dt_inicio_vigencia);
        this.editedQuadro.dt_fim_vigencia = this.editedQuadro.dt_fim_vigencia
          ? this.normalizeVigenciaForApi(this.editedQuadro.dt_fim_vigencia)
          : null;

        if (!this.editedQuadro.dt_inicio_vigencia) {
          EventBus.$emit('show-alert', {
            mensagem: `${this.$t('crudQuadros.form.fields.validityStart')} é obrigatório`,
            tipo: 'error',
          });
          if (this.csvBulkSaving) {
            this.abortCsvBulkSave();
          }
          return;
        }

        if (this.editedIndexQuadro === -1) {
          this.operacao = 0;

          if (this.updateExisting && this.quadroConflito) {
            this.applyUpdateQuadroExistente();
            return;
          }

          if (!this.substitute && !this.updateExisting) {
            if (!this.pendingCsvPayload) {
              await this.reloadQuadrosList();
            }
            const conflito = this.findQuadroConflito(quadro);
            if (conflito) {
              if (this.csvBulkSaving && this.csvBulkConflictMode) {
                this.applyCsvBulkConflictResolution(conflito);
                return;
              }
              this.promptQuadroConflito(conflito);
              return;
            }
          }

          if (this.substitute && this.csvBulkSaving) {
            const conflito = this.findQuadroConflito(quadro);
            if (conflito) {
              this.applyCsvBulkConflictResolution(conflito);
              return;
            }
          }

          if (this.substitute) {
            const quadroAtivoIndex = this.quadroConflito
              ? this.quadrosAtivos.findIndex((q) => q.id_quadro === this.quadroConflito.id_quadro)
              : this.findQuadroAtivoConflitoIndex(quadro);
            let quadroAnterior = quadroAtivoIndex !== -1
              ? this.quadrosAtivos[quadroAtivoIndex]
              : this.quadroConflito;
            if (!quadroAnterior || !quadroAnterior.id_quadro) {
              this.substitute = false;
              this.executeInsertQuadro();
              return;
            }
            quadroAnterior = this.ajustarQuadroAnteriorSubstituicao(quadroAnterior, this.editedQuadro);
            this.substitute = false;
            apiController.request(apiController.endpoints.updateQuadro, {
              data: this.buildQuadroApiPayload(quadroAnterior),
              silent: true,
              onSuccess: () => {
                this.executeInsertQuadro();
              },
              onError: (error) => this.handleQuadroApiConflict(error),
            });
          } else {
            this.executeInsertQuadro();
          }
        } else {
          this.operacao = 1;
          this.editedQuadro.dt_inicio_vigencia = this.normalizeVigenciaForApi(
            DateUtils.getDateSQLFormatted(this.inicioVigencia) || this.editedQuadro.dt_inicio_vigencia
          );
          this.editedQuadro.dt_fim_vigencia = this.fimVigencia
            ? this.normalizeVigenciaForApi(DateUtils.getDateSQLFormatted(this.fimVigencia))
            : null;

          let quadroAtivoIndex = this.quadrosAtivos.findIndex((q) => {
            if (q.id_quadro === quadro.id_quadro) {
              return false;
            }

            let inicioVigencia = DateUtils.getDateSQLFormatted(new Date(q.dt_inicio_vigencia));
            let fimVigencia = DateUtils.getDateSQLFormatted(new Date(q.dt_fim_vigencia));

            let linhaIgual = q.id_linha == quadro.id_linha;
            let categoriaIgual = q.id_categoria_quadro == quadro.id_categoria_quadro;

            let vigenciaIgual =
              (q.dt_fim_vigencia === null && quadro.dt_inicio_vigencia > inicioVigencia) ||
              (quadro.dt_inicio_vigencia < fimVigencia && quadro.dt_inicio_vigencia > inicioVigencia) ||
              (quadro.dt_fim_vigencia > inicioVigencia && quadro.dt_fim_vigencia < fimVigencia);

            let frequenciaIgual = (q.valido_segunda == quadro.valido_segunda && q.valido_segunda == 1) ||
              (q.valido_terca == quadro.valido_terca && q.valido_terca == 1) ||
              (q.valido_quarta == quadro.valido_quarta && q.valido_quarta == 1) ||
              (q.valido_quinta == quadro.valido_quinta && q.valido_quinta == 1) ||
              (q.valido_sexta == quadro.valido_sexta && q.valido_sexta == 1) ||
              (q.valido_sabado == quadro.valido_sabado && q.valido_sabado == 1) ||
              (q.valido_domingo == quadro.valido_domingo && q.valido_domingo == 1);

            if (linhaIgual && categoriaIgual && vigenciaIgual && frequenciaIgual) {
              console.log(q);
            }

            return linhaIgual && categoriaIgual && vigenciaIgual && frequenciaIgual;
          });

          if (quadroAtivoIndex !== -1 && !this.substitute) {
            this.mensagemdialog = this.$t('crudQuadros.messages.confirmSubstitution')
            this.confirmDialogSubst = true;
          } else {
            if (this.substitute) {
              let quadroAnterior = this.quadrosAtivos[quadroAtivoIndex];
              let inicioVigenciaAnterior = !quadroAnterior.dt_inicio_vigencia ? null : DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_inicio_vigencia));
              let fimVigenciaAnterior = !quadroAnterior.dt_fim_vigencia ? null : DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_fim_vigencia));

              if (inicioVigenciaAnterior < this.editedQuadro.dt_inicio_vigencia) {
                if (fimVigenciaAnterior > this.editedQuadro.dt_inicio_vigencia && (fimVigenciaAnterior < this.editedQuadro.dt_fim_vigencia || this.editedQuadro.dt_fim_vigencia === null)) {
                  quadroAnterior.dt_fim_vigencia = this.editedQuadro.dt_inicio_vigencia;
                  quadroAnterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_inicio_vigencia));
                } else if (fimVigenciaAnterior > this.editedQuadro.dt_inicio_vigencia && fimVigenciaAnterior > this.editedQuadro.dt_fim_vigencia) {
                  quadroAnterior.dt_inicio_vigencia = this.editedQuadro.dt_fim_vigencia;
                  quadroAnterior.dt_fim_vigencia = DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_fim_vigencia));
                }
              } else {
                if (this.editedQuadro.dt_fim_vigencia !== null && inicioVigenciaAnterior < this.editedQuadro.dt_fim_vigencia) {
                  quadroAnterior.dt_inicio_vigencia = this.editedQuadro.dt_fim_vigencia;
                  quadroAnterior.dt_fim_vigencia = DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_fim_vigencia));
                } else {
                  quadroAnterior.dt_fim_vigencia = this.editedQuadro.dt_inicio_vigencia;
                  quadroAnterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(quadroAnterior.dt_inicio_vigencia));
                }
              }

              if (quadroAnterior.dt_fim_vigencia <= quadroAnterior.dt_inicio_vigencia) {
                quadroAnterior.cancelado = 1;
              }
              this.substitute = false;

              apiController.request(apiController.endpoints.updateQuadro, {
                data: this.buildQuadroApiPayload(quadroAnterior),
                onSuccess: () => {
                  this.persistQuadroEditado();
                },
              });
            } else {
              this.persistQuadroEditado();
            }
          }
        }
      }
    },
    serializeViagens(viagens) {
      return JSON.stringify((viagens || [])
        .map((v) => [
          String(v.horario_saida || '').substring(0, 5),
          String(v.horario_chegada || '').substring(0, 5),
          Number(v.id_sentido),
          Number(v.id_turno),
          Number(v.escalonamento),
          v.lotacao == null || v.lotacao === '' ? null : Number(v.lotacao),
        ])
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
    },
    viagensAlteradas() {
      return this.viagensSnapshot !== null &&
        this.serializeViagens(this.editedQuadro.viagens) !== this.viagensSnapshot;
    },
    persistQuadroEditado() {
      if (!this.viagensAlteradas()) {
        apiController.request(apiController.endpoints.updateQuadro, {
          data: this.buildQuadroApiPayload(this.editedQuadro),
          onSuccess: (response) => {
            this.updateQuadrosTable(response.data.erro);
          },
        });
        return;
      }

      // As viagens previstas de um dia saem de quadros_viagens do quadro vigente naquele dia,
      // então trocar as viagens no lugar reescreveria o previsto dos dias que já passaram.
      // Quadro que ainda não entrou em vigência pode ser alterado direto; o vigente vira versão.
      const original = this.quadros[this.editedIndexQuadro] || this.editedQuadro;
      const inicioOriginal = new Date(original.dt_inicio_vigencia);
      if (isNaN(inicioOriginal.getTime()) || inicioOriginal.getTime() > Date.now()) {
        apiController.request(apiController.endpoints.updateQuadro, {
          data: this.buildQuadroApiPayload(this.editedQuadro),
          silent: true,
          onSuccess: (response) => {
            if (response.data.erro) {
              this.updateQuadrosTable(true);
              return;
            }
            this.updateViagens();
          },
          onError: (error) => EventBus.$emit('show-error', { error }),
        });
        return;
      }
      this.prepararVersionamentoQuadro(original);
    },
    async prepararVersionamentoQuadro(original) {
      const fimEditado = this.editedQuadro.dt_fim_vigencia ? new Date(this.editedQuadro.dt_fim_vigencia) : null;
      if (fimEditado && !isNaN(fimEditado.getTime()) && fimEditado.getTime() <= Date.now()) {
        EventBus.$emit('show-alert', { mensagem: this.$t('crudQuadros.messages.tripsEditEndedBeforeToday'), tipo: 'error' });
        return;
      }

      // Escala aberta presa a quadro encerrado fica sem viagens futuras; avisa e fecha junto.
      let escalas;
      try {
        const response = await apiController.request(apiController.endpoints.getallEscalas, { silent: true });
        escalas = (response.data || []).filter((e) =>
          Number(e.id_quadro) === Number(original.id_quadro) && Number(e.ativo) === 1
        );
      } catch (error) {
        EventBus.$emit('show-error', { error });
        return;
      }

      if (escalas.length === 0) {
        this.versionarQuadroComViagens(original, []);
        return;
      }
      this.quadroOriginalVersionamento = original;
      this.escalasAbertasQuadro = escalas;
      this.confirmDialogEscalas = true;
    },
    closeConfirmEscalas() {
      this.confirmDialogEscalas = false;
      this.quadroOriginalVersionamento = null;
      this.escalasAbertasQuadro = [];
    },
    confirmVersionamentoComEscalas() {
      const original = this.quadroOriginalVersionamento;
      const escalas = this.escalasAbertasQuadro;
      this.closeConfirmEscalas();
      this.versionarQuadroComViagens(original, escalas);
    },
    async versionarQuadroComViagens(original, escalas) {
      const agora = new Date();
      agora.setMilliseconds(0);

      // A original termina e a nova versão começa no instante da edição, registrando quando a
      // mudança ocorreu. Nas consultas por dia (dt_inicio <= data), a versão nova só passa a
      // contar no dia seguinte; o dia da edição segue com o previsto da original.
      const momentoEdicao = DateUtils.getDateSQLFormatted(agora);
      const novo = Object.assign({}, this.editedQuadro, {
        id_quadro: null,
        cancelado: 0,
        dt_inicio_vigencia: momentoEdicao,
      });
      const anterior = Object.assign({}, original, {
        cancelado: original.cancelado || 0,
        dt_fim_vigencia: momentoEdicao,
      });

      let idNovo = null;
      try {
        const insert = await apiController.request(apiController.endpoints.insertQuadro, {
          data: this.buildQuadroApiPayload(novo),
          silent: true,
        });
        idNovo = insert.data.insertId;
        const viagens = (this.editedQuadro.viagens || []).map((v) => [
          idNovo,
          v.horario_saida,
          v.horario_chegada,
          v.id_sentido,
          v.id_turno,
          v.escalonamento,
          v.lotacao,
        ]);
        await apiController.request(apiController.endpoints.insertViagensbulk, { data: viagens, silent: true });
        for (const escala of escalas) {
          await apiController.request(apiController.endpoints.updateEscala, {
            data: this.buildEscalaEncerradaPayload(escala, momentoEdicao),
            silent: true,
          });
        }
        await apiController.request(apiController.endpoints.updateQuadro, {
          data: this.buildQuadroApiPayload(anterior),
          silent: true,
        });
      } catch (error) {
        if (idNovo) {
          // Desfaz a versão nova para não deixar dois quadros vigentes para a linha.
          apiController.request(apiController.endpoints.updateQuadro, {
            data: this.buildQuadroApiPayload(Object.assign({}, novo, { id_quadro: idNovo, cancelado: 1 })),
            silent: true,
          }).catch(() => {});
        }
        EventBus.$emit('show-error', { error });
        return;
      }
      this.updateQuadrosTable(false, this.$t(
        escalas.length > 0
          ? 'crudQuadros.messages.successUpdateNewVersionSchedules'
          : 'crudQuadros.messages.successUpdateNewVersion'
      ));
    },
    buildEscalaEncerradaPayload(escala, momentoEdicao) {
      let inicio = DateUtils.getDateSQLFormatted(new Date(escala.dt_inicio_vigencia));
      // Escala que ainda nem começou fica com vigência vazia em vez de terminar antes de iniciar.
      if (inicio > momentoEdicao) {
        inicio = momentoEdicao;
      }
      return {
        id_escala: escala.id_escala,
        descricao: escala.descricao,
        dt_inicio_vigencia: inicio,
        dt_fim_vigencia: momentoEdicao,
        valido_segunda: escala.valido_segunda,
        valido_terca: escala.valido_terca,
        valido_quarta: escala.valido_quarta,
        valido_quinta: escala.valido_quinta,
        valido_sexta: escala.valido_sexta,
        valido_sabado: escala.valido_sabado,
        valido_domingo: escala.valido_domingo,
        id_quadro: escala.id_quadro,
        observacoes: escala.observacoes,
      };
    },
    saveViagem() {
      this.$refs.formViagem.validate();
      if (this.formViagemValidado) {
        // Converte Date para formato HH:mm
        if (this.horarioSaida) {
          const hours = String(this.horarioSaida.getHours()).padStart(2, '0');
          const minutes = String(this.horarioSaida.getMinutes()).padStart(2, '0');
          this.editedViagem.horario_saida = `${hours}:${minutes}`;
        }
        if (this.horarioChegada) {
          const hours = String(this.horarioChegada.getHours()).padStart(2, '0');
          const minutes = String(this.horarioChegada.getMinutes()).padStart(2, '0');
          this.editedViagem.horario_chegada = `${hours}:${minutes}`;
        }
        
        this.editedViagem.descricao_sentido = this.sentidos.find((s) => this.editedViagem.id_sentido === s.id_sentido).descricao_sentido;
        this.editedViagem.descricao_turno = this.turnos.find((s) => this.editedViagem.id_turno === s.id_turno).descricao_turno;
        
        if (this.editedIndexViagem === -1) {
          // Nova viagem
          this.editedQuadro.viagens.push(this.editedViagem);
        } else {
          // Edição de viagem existente
          Object.assign(this.editedQuadro.viagens[this.editedIndexViagem], this.editedViagem);
        }
      }
      this.closeViagem();
    },
    insertViagensBulk(id_quadro) {
      let temp = this.editedQuadro.viagens.map((v) => {
        return [
          id_quadro,
          v.horario_saida,
          v.horario_chegada,
          v.id_sentido,
          v.id_turno,
          v.escalonamento,
          v.lotacao
        ];
      });

      apiController.request(apiController.endpoints.insertViagensbulk, {
        data: temp,
        silent: true,
        onSuccess: (response) => {
          this.onQuadroInsertComplete(response.data.erro);
        },
        onError: (error) => this.handleQuadroApiConflict(error),
      });
    },
    updateViagens() {
      apiController.request(apiController.endpoints.deleteViagensbyquadro, {
        data: this.editedQuadro,
        silent: true,
        onSuccess: () => {
          this.insertViagensBulk(this.editedQuadro.id_quadro);
        },
        onError: (error) => this.handleQuadroApiConflict(error),
      });
    },
    formatDate(date) {
      if (!date)
        return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    formatHoraProgramada(date, time) {
      if (!date || !time)
        return null;
      return `${this.formatDate(date)} ${time}`;
    },
    updateQuadrosTable(status, mensagemSucesso = null) {
      let mensagem = "";
      let tipo = status ? "error" : "success";
      
      if (status) {
        if (this.operacao == 0) {
          mensagem = this.$t('crudQuadros.messages.errorInsert');
        }
        else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudQuadros.messages.errorUpdate');
          }
          else {
            mensagem = this.$t('crudQuadros.messages.errorDelete');
          }
        }
      }
      else {
        if (this.operacao == 0) {
          mensagem = this.$t('crudQuadros.messages.successInsert');
        }
        else {
          if (this.operacao == 1) {
            mensagem = mensagemSucesso || this.$t('crudQuadros.messages.successUpdate');
          }
          else {
            mensagem = this.$t('crudQuadros.messages.successDelete');
          }
        }
        this.editedQuadro = this.defaultQuadro;
      }
      
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.closeQuadro();
      this.closeUploadResultDialog();
      this.closeUploadDialog();
      this.initialize();
    },
    updateViagensTable(status) {
      let mensagem = "";
      let tipo = status ? "error" : "success";
      
      if (status) {
        if (this.operacao == 0) {
          mensagem = this.$t('crudQuadros.messages.tripErrorInsert');
        }
        else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudQuadros.messages.tripErrorUpdate');
          }
          else {
            mensagem = this.$t('crudQuadros.messages.tripErrorDelete');
          }
        }
      }
      else {
        if (this.operacao == 0) {
          mensagem = this.$t('crudQuadros.messages.tripSuccessInsert');
        }
        else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudQuadros.messages.tripSuccessUpdate');
          }
          else if (this.operacao == 2) {
            mensagem = this.$t('crudQuadros.messages.tripSuccessDelete');
          }
          else {
            mensagem = this.$t('crudQuadros.messages.tripSuccessDelete');
          }
        }
        this.editedQuadro = this.defaultQuadro;
      }
      
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaViagens();
    },
    escalonamentoRules() {
      return this.editedViagem.escalonamento > 0 || this.$t('crudQuadros.validation.escalationRequired');
    },
    lotacaoRules() {
      return (!this.editedViagem.lotacao || this.editedViagem.lotacao > 0) || this.$t('crudQuadros.validation.capacityMustBeGreaterThanZero');
    },
    getDateSQLFormatted(date) {
      if (!date) return null;

      var dtref = null;
      var dt = null;
      if (typeof date == "string") {
        dt = date;
        dtref =
          dt.substring(6, 10) +
          dt.substring(3, 5) +
          dt.substring(0, 2) +
          dt.substring(11, 13) +
          dt.substring(14, 16) +
          dt.substring(17);
      } else {
        dt = date.toLocaleString();
        dtref =
          dt.substring(6, 10) +
          dt.substring(3, 5) +
          dt.substring(0, 2) +
          dt.substring(12, 14) +
          dt.substring(15, 17) +
          dt.substring(18);
      }

      return dtref;
    },
    normalizeVigenciaForApi(value) {
      if (value == null || value === '') {
        return null;
      }
      if (value instanceof Date) {
        return DateUtils.getDateSQLFormatted(value);
      }
      const s = String(value).trim();
      if (/^[0-9]{14}$/.test(s)) {
        return `${s.substring(0, 4)}-${s.substring(4, 6)}-${s.substring(6, 8)}T${s.substring(8, 10)}:${s.substring(10, 12)}:${s.substring(12, 14)}`;
      }
      const parsed = new Date(s);
      if (!isNaN(parsed.getTime())) {
        return DateUtils.getDateSQLFormatted(parsed);
      }
      return null;
    },
    buildQuadroApiPayload(quadro) {
      return {
        id_quadro: quadro.id_quadro,
        id_linha: quadro.id_linha,
        descricao: quadro.descricao,
        id_categoria_quadro: quadro.id_categoria_quadro,
        dt_inicio_vigencia: this.normalizeVigenciaForApi(quadro.dt_inicio_vigencia),
        dt_fim_vigencia: quadro.dt_fim_vigencia
          ? this.normalizeVigenciaForApi(quadro.dt_fim_vigencia)
          : null,
        valido_segunda: quadro.valido_segunda,
        valido_terca: quadro.valido_terca,
        valido_quarta: quadro.valido_quarta,
        valido_quinta: quadro.valido_quinta,
        valido_sexta: quadro.valido_sexta,
        valido_sabado: quadro.valido_sabado,
        valido_domingo: quadro.valido_domingo,
        cancelado: quadro.cancelado != null ? quadro.cancelado : 0,
        observacoes: quadro.observacoes || null,
      };
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog)); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    submitFile() {
      this.$refs.formUpload.validate();
      if (this.formUploadValidado) {
        let formData = new FormData();
        this.mensagemUpload = "UPLOADING FILE";
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            onSuccess: () => {
              this.processaArquivo();
            },
            onError: () => {
              this.fileLoading = false;
            },
          });
        }
        else {
          console.log("There are no files.");
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = "PROCESSING FILE";
      apiController.request(apiController.endpoints.processaCsvquadros, {
        params: { file: this.arquivoCsv.name },
        onSuccess: (response) => {
          console.log(response)
          this.mensagemUpload = response.data.error ? "ERROR PROCESSING FILE" : "FILE PROCESSED SUCCESSFULLY";
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.resultCSV = response.data.result;
          this.showSaveButton = !response.data.error;
          this.uploadResultDialog = true;
          if (!response.data.error) {
            if (response.data.boards && response.data.boards.length > 0) {
              this.editedQuadro = Object.assign({}, response.data.boards[0]);
            }
            if (response.data.trips) {
              this.editedQuadro.viagens = response.data.trips;
            }
            this.formValidado = true;
          }
        },
        onError: () => {
          this.fileLoading = false;
          this.fimProcesso = true;
        },
      });
    },
    substQuadroAtivo() {
      if (this.csvBulkSaving) {
        this.csvBulkConflictMode = 'upsert';
        this.confirmDialogSubst = false;
        this.saveQuadro(this.pendingCsvPayload);
        return;
      }
      this.substitute = true;
      this.confirmDialogSubst = false;
      this.saveQuadro(this.pendingCsvPayload);
    },
    confirmUpdateQuadro() {
      if (this.csvBulkSaving) {
        this.csvBulkConflictMode = 'upsert';
        this.confirmDialogUpdate = false;
        this.saveQuadro(this.pendingCsvPayload);
        return;
      }
      this.updateExisting = true;
      this.confirmDialogUpdate = false;
      this.saveQuadro(this.pendingCsvPayload);
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      if (this.$refs.formUpload) {
        this.$refs.formUpload.resetValidation();
      }
      this.idempresaupload = null;
      this.arquivoCsv = null;
      this.arquivoLog = null;
      this.uploadDialog = false;
      this.substitute = false;
      this.initialize();
    },
    closeConfirmSubst() {
      this.fileLoading = false;
      this.fimProcesso = true;
      this.substitute = false;
      this.quadroConflito = null;
      this.confirmDialogSubst = false;
      if (this.csvBulkSaving) {
        this.skipCurrentCsvBoard();
      }
    },
    closeConfirmUpdate() {
      this.fileLoading = false;
      this.fimProcesso = true;
      this.updateExisting = false;
      this.quadroConflito = null;
      this.confirmDialogUpdate = false;
      if (this.csvBulkSaving) {
        this.skipCurrentCsvBoard();
      }
    },
    closeUploadResultDialog() {
      this.editedQuadro = Object.assign({}, this.defaultQuadro);
      this.uploadResultDialog = false;
      this.closeUploadDialog();
    },
    handleDone(data) {
      if (data.error) {
        this.mensagemProcessamentoImportacao = this.$t('crudQuadros.messages.importError');
        this.showImportButton = false;
        this.confirmDialogImportacao = true;
      } else {
        this.quadrosImportacao = data.result;
        console.log(this.quadrosImportacao);
        this.mensagemProcessamentoImportacao = this.$t('crudQuadros.messages.importSuccess', {
          count: data.result.length,
          lines: data.result.map((item) => item.cod_linha).join(", ")
        });
        this.showImportButton = true;
        this.confirmDialogImportacao = true;
      }
    },
    handleError(error) {
      this.mensagemProcessamentoImportacao = this.$t('crudQuadros.messages.importErrorDetail', {
        index: 1,
        line: 'N/A',
        error: error.message
      });
      this.confirmDialogImportacao = true;
    },
    async saveQuadroImportacao(quadro) {
      // Primeiro tenta inserir com substituição automática usando o endpoint correto
      let response;
      try {
        response = await apiController.request(apiController.endpoints.insertQuadroandupdate, {
          data: quadro,
          silent: true,
        });
      } catch (error) {
        // Se o endpoint de substituição falhar (não encontrou quadro para substituir),
        // tenta inserir normalmente
        if (error.response && error.response.status === 500 &&
          error.response.data.mensagem.includes(this.$t('crudQuadros.messages.notFound'))) {
          response = await apiController.request(apiController.endpoints.insertQuadro, {
            data: quadro,
            silent: true,
          });
        } else {
          throw error;
        }
      }
      if (quadro.viagens && quadro.viagens.length > 0) {
        await this.insertViagensBulkImportacao(response.data.insertId, quadro.viagens);
      }
      return response;
    },

    insertViagensBulkImportacao(id_quadro, viagens) {
      let temp = viagens.map((v) => {
        return [
          id_quadro,
          v.horario_saida,
          v.horario_chegada,
          v.id_sentido,
          v.id_turno,
          v.escalonamento,
          v.lotacao
        ];
      });

      return apiController.request(apiController.endpoints.insertViagensbulk, {
        data: temp,
        silent: true,
      });
    },

    importarQuadros() {
      this.confirmDialogImportacao = false;
      this.loadingImportacao = true;

      // Processa cada quadro sequencialmente para evitar conflitos
      const processarQuadro = (index) => {
        if (index >= this.quadrosImportacao.length) {
          this.initialize(); // Recarrega a lista de quadros
          EventBus.$emit('show-alert', { tipo: 'success', mensagem: this.$t('crudQuadros.messages.importSuccess') });
          this.loadingImportacao = false;
          this.closeImportDialog();
          return;
        }

        const quadro = this.quadrosImportacao[index];
        this.saveQuadroImportacao(quadro)
          .then(() => {
            // Aguarda um pouco antes de processar o próximo quadro
            setTimeout(() => {
              processarQuadro(index + 1);
            }, 100);
          })
          .catch((error) => {
            EventBus.$emit('show-error', { error: error });
            this.loadingImportacao = false;
            this.closeImportDialog();
          });
      };

      processarQuadro(0);
    },
    closeImportDialog() {
      this.importDialog = false;
      this.inicioVigenciaImportacao = null;
      this.$refs.inicioVigenciaImportacaoInput.clearHandler();
      this.fimVigenciaImportacao = null;
      this.$refs.fimVigenciaImportacaoInput.clearHandler();
    }
  },
};
</script>